import { useAuth } from "../../../../hooks/AuthContext";
import { Grid, Skeleton, Box, Typography } from "@mui/material";
import ButtonVoltar from "../../../../components/Botoes/ButtonVoltar";
import PendenciaCliente from "../../../../components/PendenciaCliente";
import TiposPanel from "../../../../util/typesTipoPanelsMeusDados";
import AlertCustomFixed from "../../../../components/AlertCustomFixed";
import useStyles from "./styles";
import { Titulo } from "../../../../components";

const Pendencias = ({ handlerCancelEdit, setPanel }) => {
  const { user } = useAuth();
  const classes = useStyles();
  const handlerPanelDocumentos = () => {
    setPanel(TiposPanel.editDocumentos);
  };

  const handlerPanelDadosCadastrais = () => {
    setPanel(TiposPanel.editDados);
  };

  return (
    <Box className={classes.root}>
      <Grid container className={classes.container}>
        {/* Cabeçalho */}
        <Grid item xs={12} className={classes.header}>
          <Box display="flex" alignItems="center" mb={2}>
            <ButtonVoltar handleVoltar={handlerCancelEdit} mostraTexto={true} />
          </Box>
          <Titulo variant="h5" className={classes.title}>
            Minhas pendências
          </Titulo>
        </Grid>

        <PendenciaCliente
          handlerPanelDocumentos={handlerPanelDocumentos}
          handlerPanelDadosCadastrais={handlerPanelDadosCadastrais}
        />
      </Grid>
    </Box>
  );
};

export default Pendencias;
